
export class RefillableDocumentInput {
    name: string;
    type: string;
    url: string;
    refillableDocument: string;
    userId: string;
    companyId: string;
}
